import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SimpleInput from 'components/SimpleInput';
import StyledSelect from 'components/StyledSelect';
import RadioButtons from 'components/RadioButtons';
import S from 'modal.scss';
import { getPhaseErrors } from '../../../../../../../reducers';

class LocationInfo extends Resetter(Validator(React.Component)) {
  constructor(props) {
    super(props);
    const { inspectionType = '', subfloorType = '', moisture = 'N/A',
            petsPresent = 'N/A', cleaningPractices = 'N/A' } = this.props;
    this.state = {
      inspectionType,
      subfloorType,
      moisture,
      petsPresent,
      cleaningPractices,
      errors: {},
    };
  }

  static VALIDATIONS = {
    inspectionType: true,
    subfloorType: true,
    moisture: true,
    petsPresent: true,
    cleaningPractices: true,
  }

  handleSubmit = () => {
    if (!this.validate()) { return; }
    const { inspectionType, subfloorType, moisture, petsPresent, cleaningPractices } = this.state;
    this.props.updateFormData({
      inspectionType, subfloorType, moisture, petsPresent, cleaningPractices, tab: 2,
    });
  }

  handleInspectionType = value => this.setState({ inspectionType: value });

  handleSubfloorType = value => this.setState({ subfloorType: value });

  handleMoisture = e => this.setState({ moisture: e.target.value });

  handlePetsPresent = e => this.setState({ petsPresent: e.target.value });

  handleCleaningPractices = e => this.setState({ cleaningPractices: e.target.value });

  render = () => {
    const {
      inspectionType, subfloorType, moisture, petsPresent, cleaningPractices, errors,
    } = this.state;
    const subfloorOptions = [
      { value: 'Wood', label: 'Wood' },
      { value: 'Concrete', label: 'Concrete' },
      { value: 'Combination', label: 'Combination' },
      { value: 'Other', label: 'Other' },
    ];
    return (<div>
      <h6 className={S.signatureTitle}>Location Info</h6>
      <RadioButtons
        text="Is the inspection onsite or virtual?"
        required
        selectedValue={inspectionType}
        onChange={this.handleInspectionType}
        radioButtons={[
          { label: 'Onsite', value: 'Onsite' },
          { label: 'Virtual', value: 'Virtual' },
        ]}
      />
      <StyledSelect
        className={S.select}
        label="Subfloor Type"
        onChange={this.handleSubfloorType}
        options={subfloorOptions}
        value={subfloorType}
        placeholder={'Select'}
        error={errors.subfloorType}
        required
      />
      <SimpleInput
        label="Moisture*"
        required
        text={moisture}
        errors={errors.moisture}
        onChange={this.handleMoisture}
      />
      <SimpleInput
        label="Pets Present*"
        required
        text={petsPresent}
        errors={errors.petsPresent}
        onChange={this.handlePetsPresent}
      />
      <SimpleInput
        label="Cleaning Practices*"
        required
        text={cleaningPractices}
        errors={errors.cleaningPractices}
        onChange={this.handleCleaningPractices}
      />
      <Button label="Next" flat inverse ripple className={S.submit} onClick={this.handleSubmit} />
    </div>);
  }
}

LocationInfo.propTypes = {
  subfloorType: PropTypes.string,
  moisture: PropTypes.string,
  petsPresent: PropTypes.string,
  cleaningPractices: PropTypes.string,
  errors: PropTypes.shape({
    subfloorType: PropTypes.arrayOf(PropTypes.string),
    moisture: PropTypes.arrayOf(PropTypes.string),
    petsPresent: PropTypes.arrayOf(PropTypes.string),
    cleaningPractices: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {})(LocationInfo);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/repairInspection/locationInfo.jsx